var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-tools-element-adder"
    },
    [
      _c(
        "courseware-tabs",
        {
          staticClass: "cw-tools-element-adder-tabs"
        },
        [
          _c(
            "courseware-tab",
            {
              style: {
                maxHeight: _vm.maxHeight + "px"
              },
              attrs: {
                name: _vm.$gettext("Blöcke"),
                selected: _vm.showBlockadder,
                index: 0
              }
            },
            [
              _c(
                "courseware-collapsible-box",
                {
                  attrs: {
                    title: _vm.textBlockHelper
                  }
                },
                [
                  _c("courseware-block-helper", {
                    attrs: {
                      blockTypes: _vm.blockTypes
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "courseware-collapsible-box",
                {
                  attrs: {
                    title: _vm.textAdderFavs,
                    open: _vm.favoriteBlockTypes.length > 0
                  }
                },
                [
                  !_vm.showEditFavs
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-element-adder-wrapper"
                        },
                        [
                          _vm.favoriteBlockTypes.length === 0
                            ? _c("courseware-companion-box", {
                                attrs: {
                                  mood: "sad",
                                  msgCompanion: _vm.textFavsEmpty
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.favoriteBlockTypes, function(
                            block,
                            index
                          ) {
                            return _c("courseware-blockadder-item", {
                              key: index,
                              attrs: {
                                title: block.title,
                                icon: block.icon,
                                type: block.type,
                                description: block.description
                              }
                            })
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showEditFavs
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-element-adder-favs-wrapper"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-element-adder-all-blocks",
                              class: {
                                "fav-edit-active": _vm.showEditFavs
                              }
                            },
                            _vm._l(_vm.blockTypes, function(block, index) {
                              return _c("courseware-blockadder-item", {
                                key: index,
                                attrs: {
                                  title: block.title,
                                  type: block.type,
                                  description: block.description
                                }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-element-adder-favs"
                            },
                            _vm._l(_vm.blockTypes, function(block, index) {
                              return _c("div", {
                                key: "fav-item-" + index,
                                staticClass: "cw-block-fav-item",
                                class: [
                                  _vm.isBlockFav(block)
                                    ? "cw-block-fav-item-active"
                                    : ""
                                ],
                                on: {
                                  click: function click($event) {
                                    return _vm.toggleFavItem(block)
                                  }
                                }
                              })
                            }),
                            0
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showEditFavs,
                          expression: "!showEditFavs"
                        }
                      ],
                      staticClass: "button",
                      on: {
                        click: function click($event) {
                          _vm.showEditFavs = true
                        }
                      }
                    },
                    [_c("translate", [_vm._v("Favoriten bearbeiten")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showEditFavs,
                          expression: "showEditFavs"
                        }
                      ],
                      staticClass: "button",
                      on: {
                        click: _vm.endEditFavs
                      }
                    },
                    [
                      _c("translate", [
                        _vm._v("Favoriten bearbeiten schließen")
                      ])
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "courseware-collapsible-box",
                {
                  attrs: {
                    title: _vm.textAdderAll
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cw-element-adder-all-blocks",
                      class: {
                        "fav-edit-active": _vm.showEditFavs
                      }
                    },
                    _vm._l(_vm.blockTypes, function(block, index) {
                      return _c("courseware-blockadder-item", {
                        key: index,
                        attrs: {
                          title: block.title,
                          type: block.type,
                          description: block.description
                        }
                      })
                    }),
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.blockCategories, function(category, index) {
                return _c(
                  "courseware-collapsible-box",
                  {
                    key: index,
                    attrs: {
                      title: category.title,
                      open:
                        category.type === "basis" &&
                        _vm.favoriteBlockTypes.length === 0
                    }
                  },
                  _vm._l(_vm.blockTypes, function(block, index) {
                    return _c(
                      "div",
                      {
                        key: index
                      },
                      [
                        block.categories.includes(category.type)
                          ? _c("courseware-blockadder-item", {
                              attrs: {
                                title: block.title,
                                icon: block.icon,
                                type: block.type,
                                description: block.description
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "courseware-tab",
            {
              style: {
                maxHeight: _vm.maxHeight + "px"
              },
              attrs: {
                name: _vm.$gettext("Abschnitte"),
                selected: _vm.showContaineradder,
                index: 1
              }
            },
            _vm._l(_vm.containerStyles, function(style, index) {
              return _c(
                "courseware-collapsible-box",
                {
                  key: index,
                  attrs: {
                    title: style.title,
                    open: index === 0
                  }
                },
                _vm._l(_vm.containerTypes, function(container, index) {
                  return _c("courseware-container-adder-item", {
                    key: index,
                    attrs: {
                      title: container.title,
                      type: container.type,
                      colspan: style.colspan,
                      description: container.description,
                      firstSection: _vm.$gettext("erstes Element"),
                      secondSection: _vm.$gettext("zweites Element")
                    }
                  })
                }),
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }